<template>
  <div>
    <div id="simulation-header"><px-logo></px-logo></div>
    <div id="simulation-content">
        <step-entity-type-option></step-entity-type-option>
        <step-goal-option v-if="canDisplayGoals"></step-goal-option>
        <step-objectives-solutions-option v-if="canDisplayObjectivesServices"></step-objectives-solutions-option>
        <step-location-option v-if="canDisplayLocations"></step-location-option>
        <step-duration-option v-if="canDisplayDuration"></step-duration-option>
        <step-summary v-if="canDisplaySummary"></step-summary>
    </div>
    <div id="simulation-footer"><airplane-progress :progress="progression"></airplane-progress></div>
    <div ref="contactForm" class="modal fade" id="popinInformationsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('summary.popin.popin_header')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-left">

            <div class="form-group">
              <input v-model="popin.name" :class="['form-control', {'is-valid': !$v.popin.name.$invalid}, {'is-invalid': $v.popin.name.$dirty && $v.popin.name.$invalid}]" :placeholder="$t('summary.popin.form_name')" />
              <div class="invalid-feedback" v-if="$v.popin.name.$dirty && (!$v.popin.name.required || !$v.popin.name.minLength)">{{$t('summary.popin.error_name_required')}}</div>
            </div>
            <div class="form-group">
              <input v-model="popin.firstname" :class="['form-control', {'is-valid': !$v.popin.firstname.$invalid}, {'is-invalid': $v.popin.firstname.$dirty && $v.popin.firstname.$invalid}]" :placeholder="$t('summary.popin.form_firstname')" />
              <div class="invalid-feedback" v-if="$v.popin.firstname.$dirty && (!$v.popin.firstname.required || !$v.popin.firstname.minLength)">{{$t('summary.popin.error_firstname_required')}}</div>
            </div>
            <div class="form-group">
              <input v-model="popin.email" :class="['form-control', {'is-valid': !$v.popin.email.$invalid}, {'is-invalid': $v.popin.email.$dirty && $v.popin.email.$invalid}]" type="email" :placeholder="$t('summary.popin.form_email')" />
              <div class="invalid-feedback" v-if="$v.popin.email.$dirty && (!$v.popin.email.required)">{{$t('summary.popin.error_email_required')}}</div>
              <div class="invalid-feedback" v-if="$v.popin.email.$dirty && ($v.popin.email.required && !$v.popin.email.email)">{{$t('summary.popin.error_email_bad')}}</div>
            </div>
            <div class="custom-control custom-checkbox">
              <input v-model="popin.newsletter" id="newsletterSubscription" class="custom-control-input" type="checkbox" />
              <label for="newsletterSubscription" class="custom-control-label">{{$t('summary.popin.newsletter')}}</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input v-model="popin.privacyPolicy" id="acceptPrivacyPolicy" :class="['custom-control-input', {'is-valid': !$v.popin.privacyPolicy.$invalid}, {'is-invalid': $v.popin.$dirty && $v.popin.privacyPolicy.$invalid}]" type="checkbox" />
              <label for="acceptPrivacyPolicy" class="custom-control-label">{{$t('summary.popin.privacy_policy')}}</label>
              <div class="invalid-feedback is-invalid" v-if="$v.popin.$dirty && !$v.popin.privacyPolicy.accepted">{{$t('summary.popin.error_privacy_policy_required')}}</div>
            </div>
            <div class="d-flex mt-2 justify-content-center">
              <button @click="openPrivacyPolicy" class="btn btn-sm btn-light">{{$t('common.see_privacy_policy')}} <i class="fas text-dark fa-external-link-square-alt"></i></button>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <px-button :disabled="loading" adRollPixel="f4d3bffb" @click="sendInformationsAndGetAudience()" :text="$t('summary.popin.cta')"></px-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { AirplaneProgress } from '@/components/UIComponents'
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import swal from 'sweetalert2'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import 'bootstrap/js/dist/modal.js'
import $ from 'jquery'

import {
  StepEntityTypeOption,
  StepGoalOption,
  StepObjectivesSolutionsOption,
  StepLocationOption,
  StepDurationOption,
  StepSummary
} from '@/components/Funnel'

export default {
  name: 'simulation',
  mixins: [validationMixin],
  components: {
    AirplaneProgress,
    StepEntityTypeOption,
    StepObjectivesSolutionsOption,
    StepLocationOption,
    StepDurationOption,
    StepSummary,
    StepGoalOption,
    'b-modal': bModal
  },
  directives: {
    'b-modal': bModalDirective
  },
  validations: {
    popin: {
      name: {
        required,
        minLength: minLength(2)
      },
      firstname: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      privacyPolicy: {
        accepted: (value) => value === true || value === 1
      }
    }
  },
  data () {
    return {
      loading: false,
      progression: 0,
      popin: {
        name: '',
        firstname: '',
        email: '',
        privacyPolicy: false,
        newsletter: false
      }
    }
  },
  watch: {
    canDisplayGoals: function (passed) {
      if (passed) {
        const isMobile = window.$('#is-mobile').is(':visible')
        this.$nextTick().then(() => {
          this.$onePage.update()
          if (!isMobile) {
            this.$onePage.moveNext()
          }
        })
        this.progression = 20
      }
    },
    canDisplayObjectivesServices: function (passed) {
      if (passed) {
        const isMobile = window.$('#is-mobile').is(':visible')
        this.$nextTick().then(() => {
          this.$onePage.update()
          if (!isMobile) {
            this.$onePage.moveNext()
          }
        })
        this.progression = 40
      }
    },
    canDisplayLocations: function (passed) {
      if (passed) {
        // const isMobile = window.$('#is-mobile').is(':visible')
        this.$nextTick().then(() => {
          this.$onePage.update()
          // if(!isMobile){
          this.$onePage.moveNext()
          // }
        })
        this.progression = 60
      }
    },
    canDisplayDuration: function (passed) {
      if (passed) {
        // const isMobile = window.$('#is-mobile').is(':visible')
        this.$nextTick().then(() => {
          this.$onePage.update()
          // if(!isMobile){
          this.$onePage.moveNext()
          // }
        })
        this.progression = 80
      }
    },
    canDisplaySummary: function (passed) {
      if (passed) {
        const isMobile = $('#is-mobile').is(':visible')
        this.$nextTick().then(() => {
          this.$onePage.update()
          if (!isMobile) {
            this.$onePage.moveNext()
          }
        })
        this.progression = 99
      }
    }
  },
  methods: {
    openPrivacyPolicy () {
      window.open(this.$t('common.privacy_policy_url'))
    },
    sendInformationsAndGetAudience (event) {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$store.dispatch('sendInformationsAndGetAudience', {
          informations: this.popin,
          simulation: this.inputs,
          lang: this.lang
        }).then((response) => {
          this.loading = false
          $('#popinInformationsModal').removeClass('show')
          $('.modal-backdrop.show').fadeOut()
          $('body').removeClass('modal-open')
          if (response.mail && response.mail.error) {
            this.$notify({message: this.$t('common.error_mail_not_send'), type: 'danger'})
          }
          this.$router.push({name: 'summary'})
        }, () => {
          this.loading = false
          this.$notify({message: this.$t('common.error_mail_not_send'), type: 'danger'})
        }).catch(() => {
          this.loading = false
          this.$notify({message: this.$t('common.error_mail_not_send'), type: 'danger'})
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      canDisplayGoals: 'form/can_display_goals',
      canDisplayObjectivesServices: 'form/can_display_objectives_services',
      canDisplayLocations: 'form/can_display_locations',
      canDisplayDuration: 'form/can_display_durations',
      canDisplaySummary: 'form/can_display_summary',
      inputs: 'form/inputs',
      lang: 'lang'
    }),
    ...mapState('session', ['user_mail', 'user_firstname', 'user_lastname'])
  },
  beforeMount () {
    const elements = document.querySelectorAll('html, body')
    for (const e of elements) {
      $(e).addClass('inSimulation').removeClass('outSimulation')
    }
  },
  mounted () {
    this.$onePage.init()
    this.popin.name = this.user_lastname
    this.popin.firstname = this.user_firstname
    this.popin.email = this.user_mail
    this.$nextTick().then(() => {
      this.$onePage.update()
    })
  },
  destroyed () {
    this.$onePage.destroy()
    const elements = document.querySelectorAll('html, body')
    for (const e of elements) {
      $(e).removeClass('inSimulation').addClass('outSimulation')
    }
  },
  // guards
  beforeRouteEnter (to, from, next) {
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'summary') {
      return next()
    } else if (this.$onePage.currentIndex !== 1) {
      this.$onePage.movePrev()
    } else {
      swal({
        title: this.$t('common.alerts.quit_simulation.title'),
        text: this.$t('common.alerts.quit_simulation.desc'),
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: '',
        cancelButtonColor: '',
        confirmButtonText: this.$t('common.alerts.quit_simulation.yes'),
        cancelButtonText: this.$t('common.alerts.quit_simulation.cancel')
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('form/reset')
          next()
        }
      })
    }
    next(false)
  }
}
</script>
